<template>
  <div class="applications-grid">
    <div v-for="item in applications" :key="item.id" class="applications-grid__item-wrapper">
      <ApplicationCard :id="item.id.toString()" :title="item.title" :description="item.description" :card-link="item.cardLink" :button-uses-esl="item.buttonUsesEsl" :external-link="item.externalLink">
      </ApplicationCard>
    </div>
  </div>
</template>

<script>
  import ApplicationCard from './ApplicationCard.vue';
  
  export default {
    name: 'ApplicationsGrid',
    components: {
      ApplicationCard,
    },
    props: {
      applications: {
        required: true,
        type: Array,
      }
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>

<style scoped lang="scss">
  $applications-grid-gap: gap-size(calc(3/4));
  $applications-grid-gap-half: calc($applications-grid-gap / 2);
  .applications-grid {
    width: calc(100% + #{$applications-grid-gap});
    margin: -($applications-grid-gap-half);
    margin-top: -($applications-grid-gap-half) + gap-size(calc(1/2));
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    @include education-breakpoint-wide-down {
      grid-template-columns: 1fr 1fr 1fr;
    }
    @include education-breakpoint-small-desktop-down {
      grid-template-columns: 1fr 1fr;
    }
    @include breakpoint-custom-down(900px) {
      grid-template-columns: 1fr;
    }
    &__item-wrapper {
      flex: 1 1 100%;
      max-width: 100%;
      padding: $applications-grid-gap-half;
    }

    &__item-wrapper:has(a[href="/mfa"]) {
      display: none;
    }
  }
</style>
